import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useRef } from 'react';
import { Provider } from 'react-redux';
import { CellSelectionStoreContext } from '../../redux/cellSelectionStoreContext';
import { cellSelectionDisabled, isCellSelectionEnabled } from '../config';
import { jsx as _jsx } from "react/jsx-runtime";
const CellSelectionConfigContext = /*#__PURE__*/createContext(cellSelectionDisabled);
export const useIsCellSelectionEnabled = () => {
  const $ = _c(2);
  const t0 = useContext(CellSelectionConfigContext);
  let t1;
  if ($[0] !== t0) {
    t1 = isCellSelectionEnabled(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const useCellSelectionConfig = () => {
  return useContext(CellSelectionConfigContext);
};
const CellSelectionScopeContext = /*#__PURE__*/createContext('');
export const useCellSelectionScopeId = () => {
  return useContext(CellSelectionScopeContext);
};
const CellSelectionTrackingContext = /*#__PURE__*/createContext(undefined);
export const useTrackCellSelection = () => {
  return useContext(CellSelectionTrackingContext);
};

// The staging-aware copy routine, published by CellSelectionEffects (which owns
// the staging DOM) so the floating action menu's Copy button can run the exact
// same code path as Cmd/Ctrl+C. Held in a mutable ref rather than context value
// so publishing it doesn't re-render consumers; readers call `.current()`.
const CopySelectionRefContext = /*#__PURE__*/createContext({
  current: null
});
export const useCopySelectionRef = () => {
  return useContext(CopySelectionRefContext);
};
export const ProvideCellSelection = t0 => {
  const $ = _c(12);
  const {
    config,
    store,
    scopeId,
    children
  } = t0;
  const copySelectionRef = useRef(null);
  const onTrackCellSelection = isCellSelectionEnabled(config) ? config.onTrackCellSelection : undefined;
  let t1;
  if ($[0] !== children || $[1] !== onTrackCellSelection) {
    t1 = /*#__PURE__*/_jsx(CopySelectionRefContext.Provider, {
      value: copySelectionRef,
      children: /*#__PURE__*/_jsx(CellSelectionTrackingContext.Provider, {
        value: onTrackCellSelection,
        children: children
      })
    });
    $[0] = children;
    $[1] = onTrackCellSelection;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== scopeId || $[4] !== t1) {
    t2 = /*#__PURE__*/_jsx(CellSelectionScopeContext.Provider, {
      value: scopeId,
      children: t1
    });
    $[3] = scopeId;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== config || $[7] !== t2) {
    t3 = /*#__PURE__*/_jsx(CellSelectionConfigContext.Provider, {
      value: config,
      children: t2
    });
    $[6] = config;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== store || $[10] !== t3) {
    t4 = /*#__PURE__*/_jsx(Provider, {
      store: store,
      context: CellSelectionStoreContext,
      children: t3
    });
    $[9] = store;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};